<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="登录地址">
              <a-input placeholder="请输入" v-model="queryParams.ipaddr"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="用户名称">
              <a-input placeholder="请输入" v-model="queryParams.userName"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="状态">
              <a-select button-style="solid" v-model="queryParams.status">
                <a-select-option
                  v-for="dict in statusOptions"
                  :key="dict.dictValue"
                  :value="dict.dictValue">
                  {{ dict.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="24" v-if="advanced">
            <a-form-item label="登录时间">
              <a-range-picker value-format="yyyy-MM-dd" @change="rangePicker" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport()" type="primary" v-hasPermi="['system:logininfor:export']">导出</a-button>
      <a-button @click="handleDeleteBatch(selectedRowKeys)" v-hasPermi="['system:logininfor:remove']" :disabled="selectedRowKeys.length === 0">删除</a-button>
      <a-button @click="handleClean()" v-hasPermi="['system:logininfor:remove']">清空日志</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- <a-card :bordered="false" class="content"> -->

        <!-- 表格 -->
        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="tableLoading"
          :data-source="list"
          :row-selection="rowSelection"
          row-key="infoId"
          :pagination="false"
        >
          <span slot="status" slot-scope="text, record">
            {{ statusFormat(record) }}
          </span>
        </a-table> -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="infoId"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.LOGIN_INFOR_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="status" slot-scope="text, record">
            {{ statusFormat(record) }}
          </span>
        </ls-api-table>

        <!-- 底部分页按钮 -->

        <!-- </a-card> -->
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { cleanLogininfor, delLogininfor, list } from '@/api/system/logininfor'
import { generateLsTableResData } from '@/utils/util.js';

export default {
  // eslint-disable-next-line
  name: 'Logininfor', // name要和rms配置菜单路由保存一致(首字母大写)
  data () {
    return {
             // 表格配置
     tableProps: {
        requestApi: generateLsTableResData(list, true),
        pageCurrent: true
      },
       // 高级搜索 展开/关闭
      advanced: true,
      // 分页数据(默认第一页):
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 0,
      // 表格等待
      tableLoading: false,
      // 表格数据
      list: [],
      // 状态数据字典
      statusOptions: [],
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        ipaddr: undefined,
        userName: undefined,
        status: undefined
      },
      columns: [
        {
          title: '访问编号',
          dataIndex: 'infoId',
          align: 'center'
        },
        {
          title: '用户名称',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '地址',
          dataIndex: 'ipaddr',
          scopedSlots: { customRender: 'ipaddr' },
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center'
        },
        {
          title: '描述',
          dataIndex: 'msg',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'accessTime',
          scopedSlots: { customRender: 'accessTime' },
          align: 'center'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      }
    }
  },
  created () {
    // this.getList()
    this.getDicts('sys_common_status').then(response => {
      this.statusOptions = response.data
    })
  },
  mounted () {
    this.onSearch();
  },
  methods: {
            /** 行选中 */
      selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      },
        // 表单搜索
     onSearch () {
      this.$refs.dataTable.searchParams = this.addDateRange(this.queryParams, this.dateRange);
      this.$refs.dataTable.getData();
    },
    // 登录状态字典翻译
    statusFormat (row, column) {
      return this.selectDictLabel(this.statusOptions, row.status)
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 查询登录日志列表 */
    getList () {
      this.tableLoading = true
      list(this.addDateRange(this.queryParams, this.dateRange)).then(response => {
          this.list = response.rows
          this.total = response.total
          this.tableLoading = false
        }
      )
    },
    // 搜索框中的日期选择
    rangePicker (date, dateString) {
      this.dateRange = dateString
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.pageNum = 1
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        ipaddr: undefined,
        userName: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    /** 批量删除按钮操作 */
    handleDeleteBatch (ids) {
      const infoIds = ids
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 操作记录编号为${infoIds}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delLogininfor(infoIds).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('system/logininfor/export', {
        ...this.queryParams
      }, `logininfor_${new Date().getTime()}.xlsx`)
    },
    /** 清空按钮操作 */
    handleClean () {
      const self = this
      this.$confirm({
        title: '警告',
        content: `是否确认清空所有操作日志数据项?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          cleanLogininfor().then(response => {
            if (response.code === 200) {
              self.$message.success('清空成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    }
  }
}
</script>
